import React from 'react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Row, Col, Label } from 'react-bootstrap';
import moment from 'moment';
import 'moment-timezone';

import ClientInfos from 'components/layout/client/ClientInfos';
import OrderInfos from 'components/layout/order/OrderInfos';
import OrderPaymentInfos from 'components/layout/order/OrderPaymentInfos';
import OrderServicesInfos from 'components/layout/order/OrderServicesInfos';
import IntlDateTime from 'components/layout/IntlDateTime';
import IntlDateRelative from 'components/layout/IntlDateRelative';

class OrderHeader extends React.Component {
  render() {
    const {
      intl: { messages },
      entity,
      entityLoaded,
    } = this.props;

    if (entityLoaded) {
      const momentWeekAgo = moment()
        .subtract(7, 'days')
        .startOf('day');
      const createdDate = moment(entity.getCdate()).isAfter(momentWeekAgo) ? (
        <IntlDateRelative date={entity.getCdate()} />
      ) : (
        <IntlDateTime date={entity.getCdate()} />
      );

      return (
        <div class="clearfix p-t-20 p-l-20 p-r-20">
          <h3>
            {entity.getIsClosed() && (
              <Label bsStyle="primary" class="m-r-20" style={{ fontSize: 'inherit' }}>
                {messages.closed}
              </Label>
            )}
            {entity.getAuthorizationRejected() && (
              <Label bsStyle="danger" class="m-r-20" style={{ fontSize: 'inherit' }}>
                {messages.order_cancelled}
              </Label>
            )}
            {entity.getAuthorizationPending() && (
              <Label bsStyle="warning" class="m-r-20" style={{ fontSize: 'inherit' }}>
                {messages.not_authorized}
              </Label>
            )}

            <span>{messages.order}</span>
            <span class="hint-text fs-13">
              <i class="fa fa-calendar m-r-5 m-l-15" />
              {createdDate}
            </span>
          </h3>
          <Row>
            <Col xs={12} md={6}>
              <div class="card card-default bg-master-lighter padding-20 sm-padding-10">
                <div class="font-secondary fs-12 all-caps m-b-10">{messages.order}</div>
                <OrderInfos entity={entity} entityLoaded={entityLoaded} showProgress showActions={false} />
              </div>

              <div class="card card-default bg-master-lighter m-t-20 padding-20 sm-padding-10">
                <div class="font-secondary fs-12 all-caps m-b-10">{messages.payment_details}</div>
                <OrderPaymentInfos entity={entity} entityLoaded={entityLoaded} />
              </div>
            </Col>
            <Col xs={12} md={6}>
              <div class="card card-default bg-master-lighter padding-20 sm-padding-10">
                <div class="font-secondary fs-12 all-caps m-b-10">{messages.client}</div>
                <ClientInfos entity={entity.getTarget()} addEditAction />
              </div>

              {!!entity.getServices().length && (
                <div class="card card-default bg-master-lighter m-t-20 padding-20 sm-padding-10">
                  <div class="font-secondary fs-12 all-caps m-b-10">{messages.services}</div>
                  <OrderServicesInfos entity={entity} entityLoaded={entityLoaded} />
                </div>
              )}
            </Col>
          </Row>
        </div>
      );
    }

    return null;
  }
}

export default withRouter(injectIntl(OrderHeader));
